import React from "react";
import "./_notificationShimmer.scss";

// Base shimmer block — a single animated placeholder.
const S = ({ width = "100%", height = 14, radius = 8, style = {} }) => (
    <span className="notif-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

// Full-page skeleton for the notification pages: finance header bar + table card.
const NotificationPageShimmer = ({ rows = 6, cols = 6 }) => (
    <div style={{ padding: "24px 28px", minHeight: "100vh", background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)" }}>
        {/* Header bar */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, padding: "18px 24px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", marginBottom: 18 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <S width={46} height={46} radius={12} />
                <div>
                    <S width={190} height={16} style={{ marginBottom: 8 }} />
                    <S width={250} height={10} />
                </div>
            </div>
            <S width={170} height={40} radius={9} />
        </div>

        {/* Table card */}
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", padding: "18px 20px" }}>
            <S width={160} height={14} style={{ marginBottom: 16 }} />
            {/* Header row */}
            <div style={{ display: "flex", gap: 16, padding: "12px 0", borderBottom: "2px solid #f1f5f9" }}>
                {Array.from({ length: cols }).map((_, i) => (
                    <div key={i} style={{ flex: 1 }}><S width="60%" height={11} /></div>
                ))}
            </div>
            {/* Body rows */}
            {Array.from({ length: rows }).map((_, r) => (
                <div key={r} style={{ display: "flex", gap: 16, padding: "14px 0", borderBottom: "1px solid #f5f7fa", alignItems: "center" }}>
                    {Array.from({ length: cols }).map((_, c) => (
                        <div key={c} style={{ flex: 1 }}><S width={c === 0 ? "80%" : "55%"} height={12} /></div>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default NotificationPageShimmer;
